// extracted by mini-css-extract-plugin
export default {"empty":"SMLChartEmpty_empty__VRViu","icon":"SMLChartEmpty_icon__oWzOn","title":"SMLChartEmpty_title__mDJfR","text":"SMLChartEmpty_text__Q+zLG"};